import { FinPublicError } from 'server';
import { API_BASE_URL } from '../constants';

type Methods = 'GET' | 'POST' | 'PUT' | 'DELETE';
type Options = { method: Methods; body?: NonNullable<object>; userToken?: string | null };
export type ErrorResponse = { error: FinPublicError };

export const appFetch = async <T>(url: string, options: Options = { method: 'GET' }): Promise<T> => {
  const headers: HeadersInit = {};

  // Add authorization header if userToken is provided
  if (options.userToken) {
    headers['Authorization'] = `Bearer ${options.userToken}`;
  }

  const bodyIsFormData = options.body instanceof FormData;
  const bodyToSend = (() => {
    if (bodyIsFormData || options.body === undefined) {
      return options.body as BodyInit;
    }
    return JSON.stringify(options.body);
  })();

  if (!bodyIsFormData) {
    headers['Content-Type'] = 'application/json';
  }

  const res = await fetch(`${API_BASE_URL}${url}`, {
    method: options.method,
    headers,
    body: bodyToSend
  });

  if (res.ok) {
    const resJson = await res.json();
    return resJson as T;
  }

  try {
    const errJson: { error: FinPublicError } = await res.json();
    throw errJson;
  } catch (e: unknown) {
    if (typeof e === 'object' && e !== null && 'error' in e) {
      const error = e as { error: FinPublicError };
      if (error.error && error.error.message) {
        throw new Error(error.error.message);
      }
    }
    throw new Error('Failed to fetch');
  }
};
